module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-t-mobile-intro-card1.2.7a23586b.jpg";